import { useTranslations } from 'next-intl';
import { useLanguagesPairs } from 'providers/ClientProviders/useLanguagesPairs';
import { Option } from 'types/Option';

interface IUseOptionsPairLanguagesIn {
  noAny?: boolean;
}
interface IUseOptionsPairLanguagesOut {
  optionsLanguages: Option[];
}

export default function useOptionsPairLanguages(
  { noAny }: IUseOptionsPairLanguagesIn = { noAny: false }
): IUseOptionsPairLanguagesOut {
  const t = useTranslations();
  const { data: languagesDescription } = useLanguagesPairs();

  const optionsPairLanguagesInital = noAny
    ? []
    : [
        {
          label: t('translation.index.any_language'),
          value: { sourceLanguageCode: undefined, targetLanguageCode: undefined }
        }
      ];

  const optionsLanguages = [
    ...optionsPairLanguagesInital,
    ...(languagesDescription?.length
      ? (languagesDescription ?? [])?.map?.(
          ({ description, sourceLanguageCode, targetLanguageCode }) => ({
            label: description,
            value: { sourceLanguageCode, targetLanguageCode }
          })
        ) ?? []
      : [])
  ];

  return { optionsLanguages };
}
